/* Component Dependencies */
var brandSpecificContentTemplate = require('templates/brandSpecificContent.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'brandSpecificContent',
  template: {
    'brandSpecificContent': brandSpecificContentTemplate
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  }
});
